import cn from 'classnames';

import { IConDefaultType } from '../types';

interface IContestIconProps extends IConDefaultType {}

function ContestIcon({ className, size = 24, rotate, flip }: IContestIconProps) {
  return (
    <i
      className={cn('dds-icon', className, { flip })}
      style={{
        width: size,
        minWidth: size,
        height: size,
        transform: `rotate(${rotate}deg)`,
      }}
    >
      <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M21.5999 11.9999C21.5999 17.2991 17.2991 21.5999 11.9999 21.5999C6.7007 21.5999 2.3999 17.2991 2.3999 11.9999C2.3999 6.7007 6.7007 2.3999 11.9999 2.3999C17.2991 2.3999 21.5999 6.7007 21.5999 11.9999Z"
          fill="#FE008A"
        />
        <path
          opacity="0.65"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M8.31358 14.0737H6.77758C6.77758 14.0737 6.31678 14.1505 6.54718 14.6113C6.85438 15.0721 7.08478 15.5329 7.08478 15.5329C7.08478 15.5329 7.16158 15.6097 7.08478 15.6865C7.00798 15.7633 6.47038 16.6849 6.47038 16.6849C6.47038 16.6849 6.31678 17.2225 6.77758 17.2225C7.23838 17.2225 9.38878 17.2225 9.38878 17.2225C9.38878 17.2225 9.69598 17.2225 9.69598 16.9153V15.7633L8.31358 14.0737Z"
          fill="white"
        />
        <path
          opacity="0.65"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M15.6866 14.0737H17.2226C17.2226 14.0737 17.6834 14.1505 17.453 14.6113C17.1458 15.0721 16.9154 15.5329 16.9154 15.5329C16.9154 15.5329 16.8386 15.6097 16.9154 15.6865C16.9922 15.7633 17.5298 16.6849 17.5298 16.6849C17.5298 16.6849 17.6834 17.2225 17.2226 17.2225C16.7618 17.2225 14.6114 17.2225 14.6114 17.2225C14.6114 17.2225 14.3042 17.2225 14.3042 16.9153V15.7633L15.6866 14.0737Z"
          fill="white"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12.3067 6.23976L12.9211 7.54536C12.9979 7.62216 13.0747 7.69896 13.1515 7.69896L14.5339 7.92936C14.8411 8.00616 14.9179 8.31336 14.7643 8.54376L13.7659 9.54216C13.6891 9.61896 13.6123 9.77256 13.6891 9.84936L13.9195 11.2318C13.9963 11.539 13.6891 11.7694 13.3819 11.6158L12.0763 10.9246C11.9995 10.8478 11.8459 10.8478 11.7691 10.9246L10.5403 11.6158C10.3099 11.7694 10.0027 11.539 10.0027 11.2318L10.2331 9.84936C10.2331 9.77256 10.2331 9.61896 10.1563 9.54216L9.15785 8.54376C9.00425 8.31336 9.08105 8.00616 9.38825 7.92936L10.7707 7.77576C10.8475 7.77576 11.0011 7.69896 11.0011 7.62216L11.6923 6.23976C11.8459 6.00936 12.1531 6.00936 12.3067 6.23976Z"
          fill="white"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M8.3916 13.4592C8.3916 13.4592 8.3916 13.0752 8.7756 13.0752H15.3036C15.3036 13.0752 15.6108 13.152 15.6108 13.4592V15.9168C15.6108 15.9168 15.6108 16.224 15.3036 16.224H8.7756C8.7756 16.224 8.3916 16.224 8.3916 15.9168C8.3916 15.6096 8.3916 13.4592 8.3916 13.4592Z"
          fill="white"
        />
      </svg>
    </i>
  );
}

export default ContestIcon;
